import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

interface RatingDisplayProps {
  rating: number;
  className?: string;
}

const RatingDisplay: React.FC<RatingDisplayProps> = ({ rating, className }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <StarIcon className="w-4 h-4 text-gray-900" />
      <span className="ml-1 text-sm text-gray-900">{rating.toFixed(2)}</span>
    </div>
  );
};

export default RatingDisplay;